import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import expenseService from "../Services/expense";
import Loading from "../Components/Loading";
import { FaArrowLeft } from "react-icons/fa6";

const ExpensesByExpenseHead = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    setLoading(true);
    expenseService
      .fetchAllExpensesByExpenseHead(params.get("id"))
      .then((res) => {
        setData(res.expenses);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
          <p className="font-bold text-3xl text-secondary">Expense Head</p>
          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-left w-full text-black text-[10px]">
                  <th className="w-[2%] py-4 pl-4">Date</th>
                  <th className="text-left w-[2%] py-4">Voucher Id</th>
                  <th className="text-left w-[2%] py-4">Title</th>
                  <th className="w-[3%] py-4 ">Account</th>
                  <th className="w-[2%] py-4">Amount</th>
                  <th className="rounded-tr-xl w-[5%] py-4">Notes</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((expense, index) => (
                  <tr
                    key={index}
                    className="bg-accent border-b border-gray-100 text-left"
                  >
                    <td className="py-4 w-[2%] pl-4 font-semibold">
                      {expense.date}
                    </td>
                    <td className="py-4 w-[2%] text-blue-500 font-bold">
                      {expense?.voucher}
                    </td>
                    <td className="py-4 w-[2%] font-semibold">
                      {expense.title}
                    </td>
                    <td className="py-4 w-[3%]">{expense.account}</td>
                    <td className="py-4 w-[2%] text-red-600 font-bold">
                      {expense.amount} AED
                    </td>
                    <td className="w-[4%] font-semibold text-[10px] text-gray-600">
                      {expense.note}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      )}
    </div>
  );
};

export default ExpensesByExpenseHead;
